import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import logo from './images/Meridian Event Tech Logo (2).png';
import Home from './pages/Home';
import Team from './pages/Team';
import Contact from './pages/Contact';
import Testimonials from './pages/Testimonials';

function App() {
  return (
    <Router>
      <div className="App">
        {/* Navigation */}
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-brand">
              <img src={logo} alt="Meridian Event Technologies" className="nav-logo" />
            </Link>
            <div className="nav-links">
              <Link to="/" className="nav-link">Home</Link>
              <Link to="/team" className="nav-link">Team</Link>
              {/* <Link to="/testimonials" className="nav-link">Testimonials</Link> */}
              <Link to="/contact" className="nav-link">Contact</Link>
            </div>
          </div>
        </nav>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/team" element={<Team />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <p>&copy; 2026 Meridian Event Technologies. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
